var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-header" }, [
        _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-bottom": "20px" },
                on: { change: _vm.handleTabChange },
                model: {
                  value: _vm.tabPosition,
                  callback: function($$v) {
                    _vm.tabPosition = $$v
                  },
                  expression: "tabPosition"
                }
              },
              [
                _c("el-radio-button", { attrs: { label: "有效" } }, [
                  _vm._v("有效")
                ]),
                _c("el-radio-button", { attrs: { label: "失效" } }, [
                  _vm._v("失效")
                ])
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.isAuthorizedUser()
                },
                on: { click: _vm.handleAdd }
              },
              [_vm._v("添加")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": _vm.headerStyle,
            "row-class-name": _vm.tableRowClassName
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              align: "center",
              width: "80",
              type: "index"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "companyName",
              label: "合作资源单位-公司名称",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.companyName || "-"))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "shortName", label: "简称", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.shortName || "-"))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "area",
              label: "合作区域/园区",
              align: "center",
              width: "250"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.areas && scope.row.areas.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(
                            typeof scope.row.areas === "string"
                              ? JSON.parse(scope.row.areas)
                              : scope.row.areas,
                            function(area, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticClass: "skill-tag",
                                  attrs: { size: "small", type: "success" }
                                },
                                [_vm._v(_vm._s(area))]
                              )
                            }
                          ),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "contact", label: "联系人", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.contact || "-"))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "电话", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "role", label: "角色", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticStyle: { color: "#219aff" } }, [
                      _vm._v(_vm._s(scope.row.role || "-"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              align: "center",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.status || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      {
                        on: {
                          command: function(command) {
                            return _vm.handleCommand(command, scope.row)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v("\n            更多操作 "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "edit",
                                  disabled: !_vm.isAuthorizedUser
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "delete",
                                  disabled:
                                    !_vm.isAuthorizedUser() ||
                                    scope.row.status !== "失效"
                                }
                              },
                              [_vm._v("删除")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "history" } },
                              [_vm._v("历史记录")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageParams.skip,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageParams.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.isEdit ? "编辑合作资源单位" : "添加合作资源单位",
            visible: _vm.dialogVisible,
            direction: "rtl",
            size: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司名称", prop: "companyName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司名称" },
                        model: {
                          value: _vm.form.companyName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "companyName", $$v)
                          },
                          expression: "form.companyName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "简称", prop: "shortName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入简称" },
                        model: {
                          value: _vm.form.shortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shortName", $$v)
                          },
                          expression: "form.shortName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "合作区域/园区", prop: "areas" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.areas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "areas", $$v)
                            },
                            expression: "form.areas"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "上海-临港", value: "上海-临港" }
                          }),
                          _c("el-option", {
                            attrs: { label: "上海-书院", value: "上海-书院" }
                          }),
                          _c("el-option", {
                            attrs: { label: "杭州-东冠", value: "杭州-东冠" }
                          }),
                          _c("el-option", {
                            attrs: { label: "杭州-通普", value: "杭州-通普" }
                          }),
                          _c("el-option", {
                            attrs: { label: "杭州-枢纽", value: "杭州-枢纽" }
                          }),
                          _c("el-option", {
                            attrs: { label: "杭州-萧山", value: "杭州-萧山" }
                          }),
                          _c("el-option", {
                            attrs: { label: "清远-清新", value: "清远-清新" }
                          }),
                          _c("el-option", {
                            attrs: { label: "怀来-东园", value: "怀来-东园" }
                          }),
                          _c("el-option", {
                            attrs: { label: "惠州-联丰", value: "惠州-联丰" }
                          }),
                          _c("el-option", {
                            attrs: { label: "昆山-千灯", value: "昆山-千灯" }
                          }),
                          _c("el-option", {
                            attrs: { label: "韶关-沐阳", value: "韶关-沐阳" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人", prop: "contact" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入联系人" },
                        model: {
                          value: _vm.form.contact,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contact", $$v)
                          },
                          expression: "form.contact"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入电话" },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "角色", prop: "role" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入角色" },
                        model: {
                          value: _vm.form.role,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "role", $$v)
                          },
                          expression: "form.role"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.status,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有效", value: "有效" }
                          }),
                          _c("el-option", {
                            attrs: { label: "失效", value: "失效" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitForm }
                        },
                        [_vm._v("确定")]
                      ),
                      _c("el-button", { on: { click: _vm.handleClose } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("history-dialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          partnerId: _vm.currentEmployeeId
        },
        on: {
          "update:visible": function($event) {
            _vm.historyDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }